import React from 'react'

import cx from 'classnames'

import styles from './SLogo.module.scss'

interface SLogoProps {
  className?: string | string[]
  shadow?: boolean
}

export default function SLogo({ className: additionalClasses, shadow }: SLogoProps): JSX.Element {
  return <div className={cx(styles.Background, additionalClasses, { [styles.Shadow]: shadow })}>S</div>
}
